import {
  Circle,
  ClipPath,
  Defs,
  G,
  Path,
  PathProps,
  Rect,
  Svg,
} from 'react-native-svg'
import {
  GestureResponderEvent,
  StyleProp,
  ViewStyle,
  View,
  ActivityIndicator,
} from 'react-native'
import Animated from 'react-native-reanimated'
import { Icon } from 'react-native-paper'
import {
  TouchableIconWithToolTip,
  TouchableIconWithToolTipTypes,
} from './meldd-tooltip'
import { useTranslation } from 'react-i18next'
import { useTheme } from '../hooks/theme.hook'
import { TargetType } from '../screens/core/perspectives/perspective-cards/types'
import { TimeLineAction, TimeLine, TimeLineObject } from '../generated/graphql'

type IconProps = {
  size: number
  allowFontScaling?: boolean
  color?: string
}

export type PressableIconProps = IconProps & {
  mode?: 'button' | 'text'
  label?: string | JSX.Element
  onPress?: () => void
  disabled?: boolean
}

export const IconSearch = 'magnify'
export const IconFilter = 'filter'
export const IconAdd = 'plus'
export const IconGoTo = 'chevron-right'
export const IconVisualization = 'dots-circle'
export const IconDecisions = 'scale-balance'
export const IconPrivate = 'lock'
export const IconImport = 'upload'
export const AttachFile = 'file'
export const IconNext = 'chevron-right'
export const IconPrevious = 'chevron-left'
export const IconClose = 'close'
export const IconFullScreen = 'fullscreen'
export const IconCopy = 'content-copy'
export const IconReject = 'close'
export const IconAccept = 'check'
export const IconCompleted = 'check-circle-outline'
export const ReviewIcon = 'rotate-left'

export const IconOriginalText = 'text-box-search-outline'
export const IconBumpList = 'information-outline'
export const IconClusterSettings = 'cog-outline'
export const IconPerspectiveSettings = 'cog-outline'
export const IconDeleteMember = 'delete'
export const IconEditProfile = 'pencil'
export const IconSaveProfile = 'content-save'
export const IconAlert = 'alert'
export const IconExit = 'stop'
export const IconManualPerspective = 'pencil'
export const IconAIPerspective = 'comment-quote-outline'

const noop = (evt: GestureResponderEvent) => {}
export const IconContributors = 'account-supervisor-circle-outline'
const AnimatedPath = Animated.createAnimatedComponent(Path)

export const IconContributions = (props: IconProps) => {
  const { t } = useTranslation('clusters')
  const size = props.size || '22'
  const Icon = (
    <Svg
      width={props.size}
      height={props.size}
      viewBox={`0 0 22 22`}
      fill="none"
    >
      <Path
        d="M1.27323 0.0930436C0.733545 0.279009 0.27246 0.749087 0.0995526 1.29665C0.00523961 1.5911 0 1.81839 0 5.25358V8.89539L0.303897 9.195H1.57188C2.70888 9.195 2.83987 9.20533 2.80843 9.27765C2.71936 9.49978 2.71936 9.91304 2.79795 10.2281C2.9499 10.8015 3.28524 11.22 3.84063 11.5092C4.0869 11.6332 4.16549 11.6487 4.66325 11.6487C5.16625 11.6487 5.23961 11.6384 5.51731 11.4989C5.88932 11.3129 6.25085 10.9358 6.429 10.5536C6.58619 10.223 6.64382 9.68574 6.55999 9.38613L6.50759 9.195H7.73366C8.98593 9.195 9.11692 9.17951 9.25839 8.99354C9.30555 8.93155 9.32127 8.45631 9.3265 7.17005V5.43438L9.15884 5.2949C8.97021 5.13993 8.76063 5.1451 8.56676 5.31556C8.08996 5.74948 7.33021 5.672 6.9844 5.15543C6.85865 4.96946 6.83769 4.88681 6.83769 4.56654C6.83769 4.23077 6.85341 4.17395 7.00012 3.99315C7.40357 3.49207 8.04804 3.43525 8.55104 3.84851C8.75539 4.01897 9.02261 4.02414 9.19551 3.84851L9.3265 3.72453V0.25318L9.19551 0.129203L9.06976 6.10352e-05H5.30772C1.83386 0.00522673 1.52473 0.0103924 1.27323 0.0930436ZM8.43577 2.77921L8.24191 2.72755C7.92753 2.6449 7.39833 2.70172 7.03156 2.86702C6.64906 3.03749 6.2299 3.44558 6.06747 3.80718C5.89456 4.18428 5.87884 4.84549 6.02555 5.23291C6.2037 5.70299 6.50759 6.0336 6.97916 6.27122C7.33021 6.44685 7.42453 6.47268 7.7651 6.47785C7.97469 6.47785 8.21047 6.46235 8.2943 6.44169L8.43577 6.40553V8.31683H5.54875L5.423 8.44598C5.24485 8.61645 5.25009 8.8799 5.423 9.08136C5.89456 9.63925 5.75833 10.3779 5.12434 10.6982C4.71565 10.9048 4.13405 10.7809 3.85635 10.4244C3.55246 10.0267 3.56293 9.53077 3.89303 9.12268C4.10785 8.85407 4.11309 8.61128 3.90875 8.44081C3.76728 8.31683 3.76728 8.31683 2.32639 8.31683H0.890734V5.01079C0.890734 1.3948 0.885494 1.49811 1.19463 1.16751C1.47757 0.873064 1.36754 0.883395 5.04574 0.87823H8.43577V2.77921Z"
        fill={props.color || 'currentColor'}
      />
      <Path
        d="M12.9045 4.54587C12.6949 4.62852 12.6792 4.74734 12.6792 6.03876V7.27853L12.5115 7.24237C12.1395 7.16488 11.6156 7.20621 11.3012 7.35085C10.1223 7.88291 9.76599 9.31381 10.5676 10.3056C10.9921 10.8325 11.8094 11.1115 12.4853 10.9565L12.6792 10.91V12.811H11.2436C9.8865 12.811 9.80266 12.8162 9.67691 12.9143C9.60356 12.9711 9.52497 13.0899 9.50925 13.1778C9.47781 13.3121 9.50401 13.3844 9.66644 13.6168C9.9127 13.9629 9.97557 14.2316 9.89174 14.5518C9.76599 15.0632 9.15819 15.43 8.66567 15.2957C7.86925 15.0839 7.60727 14.2109 8.14695 13.5755C8.28842 13.4102 8.31986 13.1519 8.20982 13.0125C8.06311 12.8213 7.94784 12.811 6.26069 12.811C4.47398 12.811 4.33251 12.8317 4.26964 13.0848C4.25392 13.1468 4.24868 14.8824 4.25392 16.9436L4.26964 20.6887L4.44778 21.0141C4.66261 21.4015 4.94031 21.6598 5.33852 21.8458L5.63194 21.9801L13.0198 21.9956C21.1674 22.0059 20.6906 22.0266 21.1779 21.6805C21.5184 21.448 21.7647 21.1123 21.8957 20.7248C22.0057 20.4046 22.0057 20.3942 21.9952 13.1571L21.9795 5.91478L21.8119 5.57385C21.6075 5.16576 21.2774 4.85065 20.8635 4.65952L20.5648 4.52005L16.7923 4.50971C14.6703 4.50455 12.9674 4.52005 12.9045 4.54587ZM20.5124 5.47053C20.7639 5.58418 20.9264 5.74948 21.0364 6.0026C21.1045 6.1679 21.115 6.63282 21.115 9.50494V12.811H20.1404C19.2706 12.811 19.1711 12.8007 19.1973 12.7283C19.2864 12.5062 19.2864 12.093 19.2078 11.7779C19.0558 11.2045 18.7205 10.786 18.1651 10.4968C17.9188 10.3728 17.8402 10.3573 17.3425 10.3573C16.8499 10.3573 16.7609 10.3728 16.4989 10.5019C16.1321 10.6776 15.7549 11.0702 15.5767 11.4524C15.4195 11.783 15.3619 12.3202 15.4457 12.6147L15.4981 12.811H13.5699V11.4421C13.5699 10.3366 13.5542 10.037 13.4914 9.92337C13.3499 9.64958 13.046 9.63409 12.7054 9.88721C12.2915 10.2023 11.778 10.192 11.3903 9.85621C10.9135 9.44296 10.8873 8.82824 11.3379 8.38915C11.7256 8.00689 12.1972 7.97073 12.6792 8.29101C12.8259 8.38915 12.9883 8.47697 13.046 8.49763C13.1875 8.53896 13.4599 8.38915 13.5175 8.23418C13.549 8.16186 13.5699 7.49032 13.5699 6.73613V5.37239H16.939C20.0985 5.37239 20.3133 5.38272 20.5124 5.47053ZM17.7983 11.3181C18.4009 11.6074 18.5476 12.3461 18.1127 12.8833C17.8979 13.1519 17.8926 13.3947 18.097 13.5652C18.2384 13.6892 18.2384 13.6892 19.6793 13.6892H21.115V17.0055C21.115 20.1308 21.1045 20.3374 21.0154 20.5337C20.9002 20.7765 20.6801 20.9935 20.4705 21.0709C20.371 21.1071 19.2025 21.1278 16.9443 21.1278H13.5699V19.2268L13.769 19.2784C14.0991 19.3714 14.6283 19.3043 15.0056 19.1183C15.6553 18.8032 16.043 18.2143 16.0745 17.4859C16.1112 16.7059 15.7444 16.0964 15.0266 15.7348C14.6755 15.5591 14.5812 15.5333 14.2406 15.5281C14.031 15.5281 13.7952 15.5436 13.7167 15.5643L13.5699 15.6005V13.6892H16.457L16.5827 13.56C16.7609 13.3895 16.7556 13.1261 16.5827 12.9246C16.2893 12.5785 16.2212 12.1704 16.3941 11.8037C16.6404 11.2716 17.2586 11.0598 17.7983 11.3181ZM6.99423 14.2419C6.99423 14.7533 7.00471 14.8256 7.14618 15.1046C7.35053 15.5127 7.68062 15.8278 8.11027 16.0292C8.56612 16.241 9.12676 16.2513 9.61404 16.0654C10.0542 15.9001 10.5205 15.43 10.6829 15.0064C10.8087 14.681 10.8453 14.2057 10.7772 13.8803L10.7353 13.6892H12.6792V16.5665L12.8102 16.6853C12.9831 16.8454 13.2608 16.8506 13.4232 16.7008C13.6328 16.5096 13.9 16.4063 14.1725 16.4063C15.2938 16.4063 15.5872 17.9354 14.555 18.3641C14.1935 18.5088 13.79 18.4364 13.4547 18.1575C13.2503 17.987 12.9831 17.9819 12.8102 18.1575L12.6792 18.2815V21.1278L9.23155 21.1174L5.78388 21.1019L5.56382 20.9573C5.44331 20.8798 5.2966 20.7248 5.23896 20.6112C5.13941 20.4149 5.13417 20.3168 5.13417 17.0469V13.6892H6.99423V14.2419Z"
        fill={props.color || 'currentColor'}
      />
    </Svg>
  )
  return <TouchableIconWithToolTip icon={Icon} tooltip={t('Contributions')} />
}
const _perspectivePath =
  'M9.95566 0.0476884C8.57122 0.189695 7.4264 0.518085 6.18396 1.13049C4.68416 1.86715 3.4639 2.83457 2.43889 4.09487C1.48931 5.26643 0.668408 6.91282 0.308988 8.38614C-0.223487 10.5695 -0.0637448 12.9614 0.757154 15.0161C2.12384 18.4553 5.07464 20.967 8.68659 21.7658C10.5991 22.1874 12.8931 22.0321 14.7213 21.362C16.2389 20.8028 17.6233 19.9153 18.7637 18.7748C21.5237 16.0057 22.6108 12.0916 21.6657 8.31957C21.1154 6.11847 19.7887 4.01056 18.0493 2.56387C17.1219 1.79615 15.8395 1.05505 14.7124 0.642342C13.2925 0.12313 11.4599 -0.107631 9.95566 0.0476884ZM11.5575 1.0728C12.1432 1.67189 13.4833 3.26059 13.4345 3.29609C13.4256 3.30497 13.1239 3.37153 12.7689 3.45141C12.4095 3.53129 11.8637 3.66442 11.5575 3.74873L10.9984 3.89962L10.4393 3.74873C10.1332 3.66442 9.58736 3.53129 9.22794 3.45141C8.87296 3.37153 8.57122 3.30497 8.56235 3.29609C8.51354 3.26059 9.8536 1.67189 10.4393 1.0728C10.7854 0.722221 10.8032 0.708908 10.9984 0.708908C11.1937 0.708908 11.2114 0.722221 11.5575 1.0728ZM9.21019 1.36569C8.80196 1.83165 8.13637 2.6615 7.83463 3.07864C7.77251 3.16296 7.7592 3.16296 7.24447 3.09195C6.68981 3.01208 5.4385 2.89226 4.98589 2.87451L4.71966 2.8612L4.98146 2.66594C5.58049 2.21773 6.49013 1.72514 7.29772 1.40119C7.90563 1.16155 9.21907 0.824287 9.63174 0.802099C9.68498 0.797661 9.53412 1.0018 9.21019 1.36569ZM13.2171 0.961856C14.4773 1.23256 15.7508 1.78727 16.8423 2.53724C17.3171 2.86563 17.326 2.88338 16.9621 2.88338C16.5894 2.88338 15.5245 2.98545 14.7746 3.08752C14.2376 3.16296 14.2243 3.16296 14.1622 3.07864C13.8605 2.6615 13.1904 1.83165 12.7822 1.36125L12.2808 0.793224L12.4938 0.81985C12.6092 0.8376 12.9375 0.899728 13.2171 0.961856ZM5.1412 3.59342C5.84229 3.63779 6.94274 3.74873 7.19123 3.79755L7.31103 3.81974L6.94274 4.38333C6.74306 4.69397 6.44132 5.18211 6.27714 5.46613L5.97985 5.98534L5.46068 6.28266C5.1767 6.44686 4.68859 6.74862 4.37798 6.94832L3.81445 7.31665L3.78782 7.17464C3.71683 6.77525 3.62808 5.77233 3.57927 4.91141L3.52602 3.94843L3.72126 3.74873C3.94757 3.51797 3.92094 3.51798 5.1412 3.59342ZM18.2756 3.74873L18.4708 3.94843L18.4176 4.91141C18.3688 5.77233 18.28 6.77525 18.209 7.17464L18.1824 7.31665L17.6189 6.94832C17.3082 6.74419 16.8201 6.44242 16.5362 6.28266L16.017 5.98534L15.7197 5.46613C15.5555 5.18211 15.2538 4.69397 15.0541 4.38333L14.6858 3.81974L14.8056 3.79755C15.236 3.7088 16.9266 3.56679 17.6987 3.55348L18.0803 3.54904L18.2756 3.74873ZM9.03714 4.13038C9.40543 4.21026 9.71161 4.2857 9.71161 4.29901C9.71161 4.31232 9.57849 4.37445 9.41431 4.43214C9.10814 4.54308 7.90563 5.04011 7.43084 5.25312C7.23116 5.34631 7.17791 5.35518 7.2001 5.30193C7.21341 5.26643 7.41753 4.94248 7.6527 4.58746C8.07425 3.94399 8.07868 3.93956 8.21624 3.96618C8.29611 3.9795 8.66441 4.05494 9.03714 4.13038ZM14.3486 4.5919C14.5838 4.94248 14.7834 5.26643 14.7967 5.30193C14.8189 5.35518 14.7657 5.34631 14.566 5.25312C14.0912 5.04011 12.8887 4.54308 12.587 4.43214C12.4184 4.37445 12.2852 4.31232 12.2852 4.29901C12.2852 4.28126 12.3518 4.25907 12.4317 4.24576C12.5071 4.23244 12.8532 4.157 13.1949 4.086C13.5366 4.015 13.8427 3.95287 13.8693 3.95287C13.9004 3.94843 14.1178 4.23688 14.3486 4.5919ZM11.7306 4.88035C12.7112 5.21762 13.6253 5.59482 14.6148 6.07409L15.5023 6.50455L15.9327 7.39209C16.3853 8.32845 16.9133 9.61538 17.1929 10.4807L17.3615 11.0044L17.1929 11.5236C16.9133 12.3934 16.3853 13.6803 15.9327 14.6167L15.5023 15.5042L14.6148 15.9347C13.683 16.3873 12.3962 16.9154 11.522 17.1994L10.9984 17.3681L10.4793 17.1994C9.60068 16.9154 8.31386 16.3873 7.38203 15.9347L6.49457 15.5042L6.06415 14.6167C5.61155 13.6803 5.08351 12.3934 4.80396 11.5236L4.63535 11.0044L4.80396 10.4807C5.08795 9.6065 5.61599 8.31957 6.06859 7.38765L6.49901 6.50011L7.34209 6.09184C7.80357 5.86552 8.46029 5.56819 8.80196 5.43062C9.56518 5.11999 10.852 4.6629 10.9807 4.6629C11.0339 4.65846 11.3712 4.76053 11.7306 4.88035ZM2.94474 5.98978C2.98024 6.39361 3.0468 6.95719 3.08673 7.25008C3.15773 7.76486 3.15773 7.77817 3.07342 7.8403C2.65631 8.14206 1.82654 8.80772 1.35619 9.22042L0.788215 9.72188L0.814839 9.50888C1.02783 7.95568 1.79992 6.0874 2.71844 4.90254L2.85599 4.72947L2.8693 4.99129C2.87374 5.13774 2.90924 5.58594 2.94474 5.98978ZM19.5402 5.2753C20.3922 6.56668 20.9868 8.09768 21.182 9.51331L21.2131 9.72632L20.685 9.2648C20.2014 8.83434 19.1852 8.01337 18.9412 7.84917L18.8347 7.78261L18.9145 7.2279C19.0166 6.47792 19.1187 5.41287 19.1187 5.04011C19.1187 4.6629 19.1409 4.67621 19.5402 5.2753ZM5.24769 7.4409C5.0347 7.9113 4.53329 9.11392 4.42679 9.41568C4.36911 9.58432 4.30699 9.71745 4.29368 9.71745C4.27593 9.71745 4.25374 9.65088 4.24043 9.571C4.22268 9.49556 4.15168 9.14498 4.07625 8.7944C4.00525 8.44826 3.94313 8.14206 3.94313 8.11987C3.94313 8.08881 4.26261 7.86692 5.18557 7.2634C5.36306 7.14802 5.3675 7.1702 5.24769 7.4409ZM17.4103 7.65391C17.7653 7.88468 18.0537 8.09768 18.0537 8.11987C18.0537 8.14206 17.9916 8.44826 17.9206 8.7944C17.8452 9.14498 17.7742 9.49556 17.7564 9.571C17.7431 9.65088 17.7209 9.71745 17.7032 9.71745C17.6899 9.71745 17.6277 9.58432 17.5701 9.41568C17.4591 9.11392 16.9621 7.9113 16.7492 7.43647C16.656 7.23677 16.6471 7.18352 16.7003 7.20571C16.7358 7.21902 17.0598 7.41872 17.4103 7.65391ZM3.44172 9.22042C3.52159 9.57988 3.65471 10.1257 3.73901 10.4364L3.89432 11.0044L3.74345 11.5635C3.65914 11.8697 3.52602 12.4156 3.44615 12.775C3.36628 13.13 3.29972 13.4318 3.29085 13.4407C3.25979 13.4851 1.80435 12.2647 1.16095 11.6478C0.703906 11.2174 0.703907 11.2174 0.703907 11.0044C0.703907 10.7958 0.708344 10.7869 1.11657 10.4009C1.72448 9.81952 3.19766 8.56808 3.27754 8.56364C3.29085 8.56364 3.36628 8.85653 3.44172 9.22042ZM19.0255 8.7944C19.5713 9.22486 20.4232 9.96152 20.8581 10.3787C21.2841 10.7869 21.2929 10.7958 21.2929 10.9999C21.2929 11.1996 21.2796 11.2174 20.9291 11.5635C20.3256 12.1537 18.7415 13.4895 18.7016 13.4407C18.6971 13.4318 18.6261 13.13 18.5507 12.775C18.4708 12.42 18.3377 11.8742 18.2534 11.568L18.1025 11.0044L18.2578 10.4364C18.3421 10.1257 18.4753 9.57988 18.5551 9.22042C18.6306 8.85653 18.706 8.56364 18.7149 8.56364C18.7237 8.56364 18.8613 8.66571 19.0255 8.7944ZM2.46107 13.6981C2.7495 13.9244 3.02905 14.1374 3.07342 14.1685C3.15773 14.2306 3.15773 14.2439 3.08229 14.7809C2.98024 15.5308 2.87818 16.5959 2.87818 16.9687C2.87818 17.3503 2.85599 17.337 2.40783 16.6536C1.80879 15.7483 1.33844 14.7054 1.06333 13.667C0.947958 13.2365 0.792652 12.4644 0.792652 12.3313C0.792652 12.3091 1.05002 12.5176 1.36063 12.7928C1.67124 13.0635 2.16821 13.4762 2.46107 13.6981ZM4.55548 12.9126C4.68416 13.2543 4.91933 13.8223 5.0702 14.1685C5.22551 14.5146 5.34531 14.8031 5.34088 14.8119C5.30538 14.8519 3.94313 13.9421 3.94313 13.8845C3.94313 13.8623 4.00525 13.5605 4.07625 13.2144C4.15168 12.8638 4.22268 12.5132 4.24043 12.4333C4.25374 12.3579 4.27593 12.2913 4.29368 12.2913C4.30699 12.2913 4.42679 12.5709 4.55548 12.9126ZM17.752 12.4111C17.7653 12.4821 17.8407 12.8416 17.9206 13.2188L18.0626 13.9022L17.9605 13.9865C17.7564 14.1463 16.6737 14.8341 16.656 14.8164C16.6471 14.8031 16.7358 14.5812 16.8556 14.3193C17.0997 13.7957 17.6544 12.4156 17.6544 12.3401C17.6544 12.2381 17.7342 12.2958 17.752 12.4111ZM21.1376 12.744C20.9779 13.6981 20.6495 14.6966 20.2102 15.5708C19.9263 16.1388 19.487 16.8577 19.2695 17.1107L19.1231 17.2837L19.1187 16.9731C19.1142 16.5915 19.0166 15.522 18.9145 14.7809C18.8391 14.2439 18.8391 14.2306 18.9234 14.1685C19.3494 13.8623 20.1703 13.201 20.6229 12.7972C20.9335 12.5265 21.1864 12.3091 21.1953 12.3179C21.2042 12.3224 21.1776 12.5132 21.1376 12.744ZM5.46068 15.7261L5.97985 16.0279L6.27714 16.5426C6.44132 16.8267 6.73862 17.3148 6.94274 17.6254L7.31103 18.189L7.16904 18.2157C6.76968 18.2867 5.76686 18.3754 4.90602 18.4242L3.93869 18.4775L3.73458 18.2689L3.52602 18.0648L3.57927 17.0974C3.62808 16.2364 3.71683 15.2335 3.78782 14.8341L3.81445 14.6921L4.37798 15.0604C4.68859 15.2601 5.1767 15.5619 5.46068 15.7261ZM18.2933 15.5087C18.3333 15.8504 18.3865 16.5648 18.4176 17.0974L18.4708 18.0648L18.2623 18.2689L18.0582 18.4775L17.0908 18.4242C16.23 18.3754 15.2272 18.2867 14.8278 18.2157L14.6858 18.189L15.0541 17.6254C15.2538 17.3148 15.5555 16.8267 15.7197 16.5382C16.0126 16.0323 16.0303 16.0146 16.3187 15.8548C16.7314 15.624 17.4769 15.1669 17.8496 14.914C18.2268 14.6566 18.1957 14.6122 18.2933 15.5087ZM8.40261 17.1728C8.79309 17.337 9.24569 17.5189 9.41431 17.5766C9.57849 17.6343 9.71161 17.6964 9.71161 17.7098C9.71161 17.7275 9.64505 17.7497 9.56961 17.763C9.48974 17.7808 9.1392 17.8518 8.78865 17.9272C8.44254 17.9982 8.13637 18.0603 8.11418 18.0603C8.07425 18.0603 7.25335 16.8444 7.2001 16.7068C7.17791 16.6536 7.23116 16.6625 7.43084 16.7556C7.57727 16.8178 8.01213 17.0086 8.40261 17.1728ZM14.7967 16.7113C14.7834 16.7468 14.5793 17.0707 14.3441 17.4213C13.9492 18.0204 13.9093 18.0648 13.7984 18.0426C13.2526 17.9405 12.2852 17.7275 12.2852 17.7053C12.2852 17.692 12.5648 17.5766 12.9065 17.4479C13.2481 17.3192 13.8161 17.084 14.1622 16.9287C14.5083 16.7734 14.8012 16.6447 14.8101 16.6447C14.8189 16.6403 14.8101 16.6713 14.7967 16.7113ZM11.5575 18.26C11.8681 18.3443 12.4139 18.4775 12.7689 18.5574C13.1239 18.6328 13.4256 18.7038 13.4345 18.7082C13.4833 18.7482 12.1477 20.3324 11.5575 20.9315C11.2114 21.2865 11.1937 21.2999 10.9984 21.2999C10.8032 21.2999 10.7854 21.2865 10.4393 20.9315C9.8536 20.3369 8.51354 18.7482 8.56235 18.7127C8.57122 18.7038 8.86852 18.6372 9.22351 18.5574C9.57849 18.4819 10.1065 18.3488 10.3994 18.2645C10.6922 18.1846 10.9452 18.1136 10.9585 18.1091C10.9762 18.1091 11.2425 18.1757 11.5575 18.26ZM7.94113 19.0677C8.22512 19.4715 8.79309 20.1682 9.259 20.6919L9.72048 21.22L9.50749 21.1889C8.092 20.9937 6.53894 20.3901 5.26544 19.5381C4.67528 19.1431 4.66197 19.1254 5.01252 19.1254C5.35862 19.1254 6.64988 19.0056 7.15129 18.9301C7.76807 18.8325 7.76807 18.8325 7.94113 19.0677ZM14.8056 18.9212C15.3869 19.01 16.6293 19.1254 16.9799 19.1254C17.3216 19.1254 17.3127 19.1431 16.8423 19.4715C15.5777 20.3413 13.9359 20.9892 12.4894 21.1889L12.2764 21.22L12.7378 20.6919C13.2038 20.1682 13.7717 19.4715 14.0557 19.0677C14.1445 18.9479 14.2421 18.8591 14.2909 18.8591C14.3353 18.8591 14.566 18.8902 14.8056 18.9212Z'

export const IconPerspective = (
  props: IconProps & { style?: StyleProp<ViewStyle> } & Pick<
      TouchableIconWithToolTipTypes,
      'onPress' | 'disabled'
    >
) => {
  const { t } = useTranslation('clusters')

  const Icon = (
    <Svg
      style={props.style}
      width={props.size || 22}
      height={props?.size || 22}
      viewBox="0 0 22 22"
      fill="none"
    >
      <G clipPath="url(#clip0_53886_37382)">
        <Rect width="22" height="22" rx="11" fill="white" />

        <Path d={_perspectivePath} fill={props.color} />
      </G>
      <Defs>
        <ClipPath id="clip0_53886_37382">
          <Rect width="22" height="22" rx="11" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  )
  return (
    <TouchableIconWithToolTip
      icon={Icon}
      tooltip={t('Perspective')}
      {...props}
    />
  )
}

export const AnimatedIconPerspective = (
  props: IconProps & {
    style?: StyleProp<ViewStyle>
    animatedProps?: Partial<Animated.AnimateProps<PathProps>>
  }
) => {
  const { animatedProps, style } = props
  return (
    <Svg
      style={props.style}
      width={props.size || 22}
      height={props?.size || 22}
      viewBox="0 0 22 22"
      fill="none"
    >
      <G clipPath="url(#clip0_53886_37382)">
        <Rect width="22" height="22" rx="11" fill="white" />

        <AnimatedPath
          d={_perspectivePath}
          fill={'currentColor'}
          animatedProps={animatedProps}
          // Workaround for
          onPressOut={noop}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_53886_37382">
          <Rect width="22" height="22" rx="11" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export const IconVote = (
  props: Omit<PressableIconProps, 'color'> & {
    selected: boolean
    loading: boolean
  }
) => {
  const { t } = useTranslation('common')
  const theme = useTheme()
  const { size, selected, loading, ...other } = props

  // If is true or undefine we show it as selected
  const color =
    selected !== false ? theme.colors.primary : theme.palettes.primary[80]!
  const Icon = (
    <Svg width={size || 22} height={size || 22} viewBox="0 0 22 22" fill="none">
      <Path
        d="M13.5 9.75095H12.99L11.49 11.2509H12.9225L14.25 12.7509H3.75L5.085 11.2509H6.6225L5.1225 9.75095H4.5L2.25 12.0009V15.0009C2.25 15.8259 2.9175 16.5009 3.7425 16.5009H14.25C15.075 16.5009 15.75 15.8334 15.75 15.0009V12.0009L13.5 9.75095ZM14.25 15.0009H3.75V14.2509H14.25V15.0009ZM8.505 11.2659C8.7975 11.5584 9.27 11.5584 9.5625 11.2659L14.3325 6.49595C14.625 6.20345 14.625 5.73095 14.3325 5.43845L10.62 1.72595C10.335 1.42595 9.8625 1.42595 9.57 1.71845L4.7925 6.49595C4.5 6.78845 4.5 7.26095 4.7925 7.55345L8.505 11.2659ZM10.095 3.30845L12.75 5.96345L9.0375 9.67595L6.3825 7.02095L10.095 3.30845Z"
        fill={color || 'black'}
      />
    </Svg>
  )

  if (loading) {
    return (
      <View style={{ padding: 2 }}>
        <ActivityIndicator />
      </View>
    )
  }
  return (
    <TouchableIconWithToolTip
      icon={Icon}
      tooltip={selected ? t('Remove Vote') : t('Votes')}
      onPress={loading ? undefined : other.onPress}
      {...other}
    />
  )
}

export const IconNoVotes = (props: Omit<PressableIconProps, 'color'>) => {
  const { t } = useTranslation('common')
  const theme = useTheme()
  const { size, ...other } = props

  // If is true or undefine we show it as selected
  const color = theme.colors.primary
  const Icon = (
    <Svg width={size || 22} height={size || 22} viewBox="0 0 22 22" fill="none">
      <Path
        d="M13.5 9.75095H12.99L11.49 11.2509H12.9225L14.25 12.7509H3.75L5.085 11.2509H6.6225L5.1225 9.75095H4.5L2.25 12.0009V15.0009C2.25 15.8259 2.9175 16.5009 3.7425 16.5009H14.25C15.075 16.5009 15.75 15.8334 15.75 15.0009V12.0009L13.5 9.75095ZM14.25 15.0009H3.75V14.2509H14.25V15.0009ZM8.505 11.2659C8.7975 11.5584 9.27 11.5584 9.5625 11.2659L14.3325 6.49595C14.625 6.20345 14.625 5.73095 14.3325 5.43845L10.62 1.72595C10.335 1.42595 9.8625 1.42595 9.57 1.71845L4.7925 6.49595C4.5 6.78845 4.5 7.26095 4.7925 7.55345L8.505 11.2659ZM10.095 3.30845L12.75 5.96345L9.0375 9.67595L6.3825 7.02095L10.095 3.30845Z"
        fill={color || 'black'}
      />
    </Svg>
  )

  return (
    <TouchableIconWithToolTip
      icon={Icon}
      tooltip={t('# of Votes')}
      onPress={other.onPress}
      {...other}
    />
  )
}
export const IconNode = (props: IconProps) => {
  const { t } = useTranslation('common')

  const Icon = (
    <Svg
      width={props.size || 22}
      height={props.size || 22}
      viewBox="0 0 24 24"
      fill="none"
    >
      <Path
        d="M2.15315 6.31492L12 0.629836L21.8468 6.31492V17.6851L12 23.3702L2.15315 17.6851V6.31492Z"
        stroke={props.color}
        strokeWidth="1.09091"
      />
      <Circle
        cx="12.0005"
        cy="12"
        r="6"
        stroke={props.color}
        strokeWidth="1.09091"
      />
      <Circle
        cx="12.0002"
        cy="17.4548"
        r="1.63636"
        fill="white"
        stroke={props.color}
        strokeWidth="1.09091"
      />
      <Circle
        cx="6.54608"
        cy="8.72723"
        r="1.63636"
        fill="white"
        stroke={props.color}
        strokeWidth="1.09091"
      />
      <Circle
        cx="17.4553"
        cy="8.72723"
        r="1.63636"
        fill="white"
        stroke={props.color}
        strokeWidth="1.09091"
      />
    </Svg>
  )
  return <TouchableIconWithToolTip icon={Icon} tooltip={t('Node')} />
}
export const IconCluster = (props: IconProps) => {
  const { t } = useTranslation('common')

  const Icon = (
    <Svg
      width={props.size || 22}
      height={props.size || 22}
      viewBox="0 0 24 24"
      fill="none"
    >
      <Circle
        cx="11.9996"
        cy="12"
        r="6"
        stroke={props.color}
        strokeWidth="1.09091"
      />
      <Circle
        cx="12.0002"
        cy="17.4548"
        r="1.63636"
        fill="white"
        stroke={props.color}
        strokeWidth="1.09091"
      />
      <Circle
        cx="6.5451"
        cy="8.72723"
        r="1.63636"
        fill="white"
        stroke={props.color}
        strokeWidth="1.09091"
      />
      <Circle
        cx="17.4543"
        cy="8.72723"
        r="1.63636"
        fill="white"
        stroke={props.color}
        strokeWidth="1.09091"
      />
    </Svg>
  )

  return <TouchableIconWithToolTip icon={Icon} tooltip={t('Cluster')} />
}

export const IconAscending = (props: IconProps) => (
  <Svg width="18" height="19" viewBox="0 0 18 19" fill="none">
    <Path
      d="M12.4686 10.9385H4.53149C4.29343 10.9385 4.1605 11.1898 4.30793 11.3614L8.27647 15.9632C8.39006 16.0949 8.60879 16.0949 8.72359 15.9632L12.6921 11.3614C12.8396 11.1898 12.7066 10.9385 12.4686 10.9385Z"
      fill={props.color || 'currentColor'}
      opacity={0.5}
    />
    <Path
      d="M12.6921 7.63903L8.72359 3.03727C8.61 2.90555 8.39127 2.90555 8.27647 3.03727L4.30793 7.63903C4.1605 7.81063 4.29343 8.06199 4.53149 8.06199H12.4686C12.7066 8.06199 12.8396 7.81063 12.6921 7.63903Z"
      fill={props.color || 'currentColor'}
    />
  </Svg>
)
export const IconDescending = (props: IconProps) => (
  <Svg width="18" height="19" viewBox="0 0 18 19" fill="none">
    <Path
      d="M12.4686 10.9385H4.53149C4.29343 10.9385 4.1605 11.1898 4.30793 11.3614L8.27647 15.9632C8.39006 16.0949 8.60879 16.0949 8.72359 15.9632L12.6921 11.3614C12.8396 11.1898 12.7066 10.9385 12.4686 10.9385Z"
      fill={props.color || 'currentColor'}
    />
    <Path
      d="M12.6921 7.63903L8.72359 3.03727C8.61 2.90555 8.39127 2.90555 8.27647 3.03727L4.30793 7.63903C4.1605 7.81063 4.29343 8.06199 4.53149 8.06199H12.4686C12.7066 8.06199 12.8396 7.81063 12.6921 7.63903Z"
      fill={props.color || 'currentColor'}
      opacity={0.5}
    />
  </Svg>
)

export const IconEagleView = (props: IconProps) => (
  <Svg width={props.size || '100%'} viewBox="0 0 768 624" {...props}>
    <Path
      fill={props.color || '#000000'}
      opacity={1}
      d="M209.951340,544.205078 C193.761261,547.085815 177.869415,548.338562 161.868988,548.086914 C125.630684,547.517090 91.678337,539.373840 62.117043,517.275391 C38.345219,499.504944 23.245125,476.014618 17.200665,446.948425 C13.802106,430.605652 14.568285,414.229950 18.192574,397.936401 C22.166107,380.072815 28.167698,363.114502 39.299603,348.315247 C49.771816,334.392944 63.556877,325.444122 80.197479,320.491608 C91.614861,317.093628 103.180809,315.199127 115.064011,315.898224 C144.277771,317.616913 169.025909,333.648254 175.898254,365.911163 C179.038742,380.654419 177.608170,395.334412 175.016754,409.970825 C174.363220,413.661957 171.971130,416.196777 168.939651,418.148804 C160.814240,423.380920 151.834488,426.200287 142.295273,427.298218 C137.882675,427.806122 134.287399,426.218750 131.056595,423.074188 C122.221245,414.474579 115.957718,404.105011 110.087776,393.442444 C107.043182,387.911987 104.118980,382.315186 101.151527,376.742432 C100.280289,375.106293 99.640198,373.394501 99.774063,371.494690 C100.104111,366.810730 97.407700,366.763702 93.990929,367.638031 C82.577721,370.558655 75.031448,377.927979 70.969681,388.652954 C65.463280,403.192383 64.229897,418.326447 65.648453,433.786316 C66.686302,445.097076 69.755249,455.527222 76.243965,464.999115 C85.569878,478.612701 99.387283,485.605499 114.005386,491.647858 C128.950043,497.825195 144.766846,500.324280 160.630035,501.283905 C173.322296,502.051727 186.025146,499.633087 198.607864,497.103119 C219.294006,492.943726 238.557037,484.928894 257.713226,476.533783 C284.484802,464.801300 309.555969,450.027679 333.776672,433.738525 C374.973907,406.032104 412.260864,373.606018 447.960907,339.263855 C456.245300,331.294586 464.389282,323.179260 472.591217,315.124329 C473.861542,313.876770 475.296875,312.731537 476.012268,310.316010 C469.185883,310.743317 462.795502,311.137695 456.405945,311.544403 C437.273468,312.762054 418.154388,312.673279 399.010132,311.532562 C387.872711,310.868896 376.829803,309.527893 365.787262,308.112762 C353.306152,306.513306 340.971405,304.076935 328.606201,301.732727 C312.252625,298.632477 296.171692,294.538025 280.134521,290.234711 C257.706940,284.216644 235.480392,277.510742 213.523361,269.919464 C189.519043,261.620392 165.424942,253.580444 141.433945,245.243439 C120.423332,237.942169 99.412064,230.651993 78.170624,224.043304 C75.712875,223.278625 74.352966,221.749649 74.021339,219.044464 C73.031425,210.969406 73.148499,202.763138 71.192062,194.804962 C70.723106,192.897400 71.932991,191.732910 72.882225,190.352539 C77.098640,184.221085 83.367371,181.627197 90.183723,179.501205 C121.080917,169.864456 151.887543,159.937607 182.772888,150.262451 C209.365402,141.932037 236.013199,133.777649 262.649841,125.588783 C282.471100,119.495163 302.157776,112.880119 322.193390,107.592308 C339.978485,102.898445 358.148987,100.071404 376.582336,98.287628 C392.259308,96.770607 407.872375,96.476311 423.461517,97.037834 C437.680573,97.549995 451.911377,98.978134 466.051453,101.261238 C477.526794,103.114090 488.892944,105.362312 500.236389,107.812271 C516.962585,111.424805 533.176331,116.899406 549.622681,121.523125 C562.393005,125.113350 575.144531,128.750336 588.039917,131.870682 C608.010376,136.702972 627.893372,141.933350 647.964600,146.300217 C661.740112,149.297318 675.421204,152.654602 689.127686,155.912064 C702.814636,159.164917 716.419312,162.771103 730.025330,166.354370 C735.663269,167.839172 740.231628,171.153275 744.001953,175.566666 C752.116699,185.065491 758.552856,195.864639 766.909363,205.181473 C767.409973,205.739624 767.496704,206.668869 767.795715,207.478760 C764.261963,211.336014 759.276978,210.528519 755.107239,211.521622 C735.673950,216.149979 716.388916,221.179230 698.055237,229.244888 C671.020508,241.138489 650.546387,259.329620 642.983948,289.041748 C639.485840,302.785431 637.167053,316.742584 644.333191,330.312286 C648.477417,338.159637 654.353088,344.402100 661.507446,349.461670 C674.230591,358.459503 688.535767,364.452667 702.648254,370.797577 C707.183777,372.836731 707.372803,373.903320 704.164917,377.662659 C686.112976,398.817902 668.129089,420.031403 650.040527,441.155243 C626.429077,468.728607 602.723206,496.220947 579.095886,523.780762 C569.341614,535.158569 559.695374,546.629089 549.971802,558.033325 C548.939636,559.243896 548.122253,561.203430 546.138184,560.684387 C544.285156,560.199585 544.223389,558.225647 543.729126,556.634644 C539.141479,541.868286 536.123047,526.701721 534.179626,511.450531 C531.547119,490.790314 530.946716,469.951965 533.208313,449.150024 C534.372864,438.439423 535.246704,427.671509 537.029236,417.060120 C539.413208,402.868896 542.365967,388.778015 546.158508,374.856384 C549.908142,361.091919 553.334229,347.240173 557.567627,333.609100 C560.715149,323.474579 563.853088,313.337128 566.986023,303.198090 C567.228271,302.414062 567.533142,301.601471 566.702576,300.584198 C564.246094,300.540100 562.758545,302.551147 561.093384,303.963806 C536.205566,325.078613 511.348236,346.229462 486.522217,367.416962 C458.658325,391.197083 430.768066,414.938599 402.260681,437.956573 C378.422302,457.204559 354.813232,476.751038 329.447571,493.977631 C304.002655,511.257965 276.763580,525.092712 247.492584,534.758301 C235.346558,538.769043 222.872101,541.498657 209.951340,544.205078 M286.793335,169.520859 C254.844452,179.685104 222.895569,189.849335 189.838898,200.366013 C191.834991,201.732376 192.448166,202.291718 193.166443,202.623489 C215.505585,212.941269 238.114090,222.594681 261.386169,230.654907 C278.179688,236.471313 295.156250,241.673141 312.472229,245.643387 C327.962189,249.194946 343.510773,252.424210 359.325470,254.436356 C372.694366,256.137329 386.069427,258.029999 399.499786,258.548950 C430.637573,259.752136 461.561554,257.664825 492.335358,252.158096 C509.845215,249.024857 527.074890,245.006744 544.010010,239.824783 C570.909180,231.593933 596.752014,220.612427 621.851196,207.923676 C625.419556,206.119705 629.447754,204.814499 632.020935,201.556992 C631.287720,199.779007 629.982239,199.554443 628.686096,199.151260 C617.595276,195.701096 606.512573,192.224274 595.446045,188.696747 C560.496826,177.556366 525.542175,166.432388 490.631195,155.173203 C486.926727,153.978470 485.511627,154.753723 485.045441,158.631989 C483.875977,168.361145 482.414307,178.030563 479.233978,187.391037 C472.575562,206.988510 459.675629,219.536148 439.036652,223.328354 C427.307007,225.483566 415.503784,225.003357 403.768555,223.178696 C390.205139,221.069794 378.825073,215.140778 371.002777,203.489349 C364.225555,193.394638 361.925476,181.829559 360.913025,170.021103 C360.373871,163.732956 360.678009,157.359909 360.824066,151.030319 C360.912598,147.192871 359.894623,145.982040 355.862823,147.294327 C333.115265,154.698318 310.300171,161.894745 286.793335,169.520859z"
    />
  </Svg>
)
export const IconFlagChina = (props: IconProps) => (
  <Svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <G clipPath="url(#clip0_54395_38326)">
      <Path
        d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
        fill="#EE1C25"
      />
      <Path
        d="M8.25 10.65L11.25 12.75L10.125 9.3L13.125 7.125H9.4125L8.25 3.75L7.125 7.125H3.375L6.375 9.3L5.25 12.75L8.25 10.65Z"
        fill="#FFFF00"
      />
      <Path
        d="M13.2375 13.2375L12.375 13.425L13.2 13.7625V14.625L13.7625 13.9875L14.5875 14.2875L14.1 13.575L14.625 12.9L13.7625 13.0875L13.2375 12.375V13.2375Z"
        fill="#FFFF00"
      />
      <Path
        d="M14.5125 10.6875L13.875 11.25L14.7375 11.175L15.1125 12L15.2625 11.1375L16.125 11.0625L15.375 10.6125L15.5625 9.75L14.925 10.3125L14.175 9.8625L14.5125 10.6875Z"
        fill="#FFFF00"
      />
      <Path
        d="M14.7375 7.7625L15 8.625L15.2625 7.8H16.125L15.45 7.275L15.7125 6.4125L15 6.9375L14.325 6.375L14.5875 7.2375L13.875 7.725L14.7375 7.7625Z"
        fill="#FFFF00"
      />
      <Path
        d="M13.2375 4.7625V5.625L13.7625 4.9125L14.625 5.1L14.1 4.425L14.5875 3.7125L13.7625 4.05L13.2 3.375V4.2375L12.375 4.575L13.2375 4.7625Z"
        fill="#FFFF00"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_54395_38326">
        <Rect width="24" height="24" fill="white" />
      </ClipPath>
    </Defs>
  </Svg>
)
export const IconFlagUK = (props: IconProps) => (
  <Svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <G clipPath="url(#clip0_54398_38963)">
      <Path
        d="M8.2502 22.6125V17.4375L4.3877 20.2875C5.4752 21.3 6.7877 22.0875 8.2502 22.6125Z"
        fill="#012169"
      />
      <Path
        d="M15.75 22.6124C17.2125 22.0874 18.525 21.2999 19.6125 20.2874L15.75 17.3999V22.6124Z"
        fill="#012169"
      />
      <Path
        d="M1.3877 15.75C1.5002 16.125 1.6502 16.4625 1.8377 16.8375L3.3002 15.75H1.3877Z"
        fill="#012169"
      />
      <Path
        d="M20.7002 15.75L22.1627 16.8375C22.3127 16.5 22.4627 16.125 22.6127 15.75H20.7002Z"
        fill="#012169"
      />
      <Path
        d="M8.8126 14.25H0.975098C1.0876 14.775 1.2376 15.2625 1.3876 15.75H3.3001L1.8376 16.8375C2.1376 17.475 2.4751 18.0375 2.8876 18.6L6.7501 15.75H8.2501V16.5L3.8626 19.725L4.3876 20.25L8.2501 17.4375V22.6125C8.7376 22.8 9.2251 22.9125 9.7501 23.025V14.25H8.8126Z"
        fill="white"
      />
      <Path
        d="M23.025 14.25H14.25V23.025C14.775 22.9125 15.2625 22.7625 15.75 22.6125V17.4375L19.6125 20.25C20.1375 19.7625 20.5875 19.2375 21.0375 18.675L17.025 15.75H19.575L21.8625 17.4375C21.975 17.25 22.0875 17.025 22.1625 16.8375L20.7 15.75H22.6125C22.7625 15.2625 22.9125 14.775 23.025 14.25Z"
        fill="white"
      />
      <Path
        d="M2.8877 18.6001C3.1877 19.0126 3.4877 19.3876 3.8252 19.7626L8.2502 16.5376V15.7876H6.7502L2.8877 18.6001Z"
        fill="#C8102E"
      />
      <Path
        d="M17.0625 15.75L21.075 18.675C21.225 18.4875 21.3375 18.3 21.4875 18.1125C21.525 18.075 21.525 18.0375 21.5625 18.0375C21.675 17.85 21.825 17.625 21.9375 17.4375L19.575 15.75H17.0625Z"
        fill="#C8102E"
      />
      <Path
        d="M15.75 1.3877V6.5627L19.6125 3.7127C18.525 2.7002 17.2125 1.9127 15.75 1.3877Z"
        fill="#012169"
      />
      <Path
        d="M8.2502 1.3877C6.7877 1.9127 5.4752 2.7002 4.3877 3.7127L8.2502 6.6002V1.3877Z"
        fill="#012169"
      />
      <Path
        d="M22.6127 8.2501C22.5002 7.8751 22.3502 7.5376 22.1627 7.1626L20.7002 8.2501H22.6127Z"
        fill="#012169"
      />
      <Path
        d="M3.3002 8.2501L1.8377 7.1626C1.6877 7.5376 1.5377 7.8751 1.3877 8.2501H3.3002Z"
        fill="#012169"
      />
      <Path
        d="M15.1875 9.7501H22.9875C22.875 9.2251 22.725 8.7376 22.575 8.2501H20.6625L22.125 7.1626C21.825 6.5251 21.4875 5.9626 21.075 5.4001L17.25 8.2501H15.75V7.5001L20.1375 4.2751L19.6125 3.7501L15.75 6.5626V1.3876C15.2625 1.2001 14.775 1.0876 14.25 0.975098V9.7501H15.1875Z"
        fill="white"
      />
      <Path
        d="M0.975098 9.7501H9.7501V0.975098C9.2251 1.0876 8.7376 1.2376 8.2501 1.3876V6.5626L4.3876 3.7501C3.8626 4.2376 3.4126 4.7626 2.9626 5.3251L6.9751 8.2501H4.4251L2.1376 6.5626C2.0251 6.7501 1.9126 6.9751 1.8376 7.1626L3.3001 8.2501H1.3876C1.2376 8.7376 1.0876 9.2251 0.975098 9.7501Z"
        fill="white"
      />
      <Path
        d="M21.1125 5.3998C20.8125 4.9873 20.5125 4.6123 20.175 4.2373L15.75 7.4623V8.2123H17.25L21.1125 5.3998Z"
        fill="#C8102E"
      />
      <Path
        d="M6.9376 8.2502L2.9626 5.3252C2.8126 5.5127 2.7001 5.7002 2.5501 5.8877C2.5126 5.9252 2.5126 5.9627 2.4751 5.9627C2.3626 6.1502 2.2126 6.3752 2.1001 6.5627L4.3876 8.2502H6.9376Z"
        fill="#C8102E"
      />
      <Path
        d="M23.025 9.75H14.25V0.975C13.5375 0.825 12.7875 0.75 12 0.75C11.2125 0.75 10.4625 0.825 9.75 0.975V9.75H0.975C0.825 10.4625 0.75 11.2125 0.75 12C0.75 12.7875 0.825 13.5375 0.975 14.25H9.75V23.025C10.4625 23.175 11.2125 23.25 12 23.25C12.7875 23.25 13.5375 23.175 14.25 23.025V14.25H23.025C23.175 13.5375 23.25 12.7875 23.25 12C23.25 11.2125 23.175 10.4625 23.025 9.75Z"
        fill="#C8102E"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_54398_38963">
        <Rect width="24" height="24" fill="white" />
      </ClipPath>
    </Defs>
  </Svg>
)

export const PNG3dEdit = require('../assets/bitmap-icons/icon-edit.png')

export const Icon3dEdit = (props: PressableIconProps) => {
  const { t } = useTranslation('contributions')
  const { size, ...other } = props
  const icon = <Icon size={size} source={PNG3dEdit} />
  return (
    <TouchableIconWithToolTip icon={icon} tooltip={t('Edits')} {...other} />
  )
}

export const PNG3dChallenge = require('../assets/bitmap-icons/icon-challenge.png')
export const Icon3dChallenge = (props: PressableIconProps) => {
  const { t } = useTranslation('contributions')
  const { size, ...other } = props
  const icon = <Icon size={size} source={PNG3dChallenge} />
  return (
    <TouchableIconWithToolTip
      icon={icon}
      tooltip={t('Challenges')}
      {...other}
    />
  )
}
export const PNG3dInquiry = require('../assets/bitmap-icons/icon-inquiry.png')
export const Icon3dInquiry = (props: PressableIconProps) => {
  const { t } = useTranslation('contributions')
  const { size, ...other } = props
  const icon = <Icon size={size} source={PNG3dInquiry} />
  return (
    <TouchableIconWithToolTip icon={icon} tooltip={t('Inquiries')} {...other} />
  )
}

export const PNG3dContributions = require('../assets/bitmap-icons/icon-cluster-contribution.png')
export const Icon3dContributions = (props: PressableIconProps) => {
  const { t } = useTranslation('clusters')
  const { size, ...other } = props
  const icon = <Icon size={size} source={PNG3dContributions} />
  return (
    <TouchableIconWithToolTip
      icon={icon}
      tooltip={t('# of Contributions')}
      {...other}
    />
  )
}
export const PNG3dPerspective = require('../assets/bitmap-icons/icon-cluster-perspective.png')
export const Icon3dPerspective = (props: PressableIconProps) => {
  const { t } = useTranslation('clusters')
  const { size, ...other } = props
  const icon = <Icon size={size} source={PNG3dPerspective} />
  return (
    <TouchableIconWithToolTip
      icon={icon}
      tooltip={t('# of Perspectives')}
      {...other}
    />
  )
}
export const PNG3dVoteCount = require('../assets/bitmap-icons/icon-cluster-thumbsup.png')
export const Icon3dVoteCount = (props: PressableIconProps) => {
  const { t } = useTranslation('clusters')
  const { size, ...other } = props
  const icon = <Icon size={size} source={PNG3dVoteCount} />
  return (
    <TouchableIconWithToolTip
      icon={icon}
      tooltip={t('# of Votes')}
      {...other}
    />
  )
}
export const PNG3dVoteSelected = require('../assets/bitmap-icons/icon-button.png')
export const PNG3dVote = require('../assets/bitmap-icons/icon-button--not_selected.png')

export const PNG3dBumpDown = require('../assets/bitmap-icons/icon-down.png')
/**
 * @deprecated Use icon BumpDown instead
 */
export const Icon3dBumpDown = (props: PressableIconProps) => {
  const { t } = useTranslation('bumps')
  const { size, color, ...other } = props
  const icon = <Icon size={size} color={color} source={PNG3dBumpDown} />
  return <TouchableIconWithToolTip icon={icon} tooltip={t('Down')} {...other} />
}
export const PNG3dBumpUp = require('../assets/bitmap-icons/icon-up.png')
/**
 * @deprecated Use icon BumpUp instead
 */
export const Icon3dBumpUp = (props: PressableIconProps) => {
  const { t } = useTranslation('bumps')
  const { size, color, ...other } = props
  const icon = <Icon size={size} color={color} source={PNG3dBumpUp} />
  return <TouchableIconWithToolTip icon={icon} tooltip={t('Up')} {...other} />
}
export const PNGCoRankBkg = require('../assets/bitmap-icons/icon-co-rank-bkg.png')

export const IconCoRankBkg = (props: PressableIconProps) => {
  const { t } = useTranslation('nodeStats')
  const { size, ...other } = props
  const icon = <Icon size={size} source={PNGCoRankBkg} />
  return (
    <TouchableIconWithToolTip icon={icon} tooltip={t('CoRank')} {...other} />
  )
}

export const CorankIcon = (props: IconProps) => {
  return (
    <Svg
      width={props.size || 24}
      height={props.size || 24}
      viewBox="0 0 24 22"
      fill="none"
    >
      <g opacity="0.5">
        <path
          d="M21.8066 0.930664H18.8623C18.3485 0.930917 17.9317 1.34752 17.9316 1.86133V19.8057C17.9318 20.3194 18.3486 20.7361 18.8623 20.7363H21.8066C22.3205 20.7363 22.7371 20.3195 22.7373 19.8057V1.86133C22.7372 1.34741 22.3206 0.930742 21.8066 0.930664ZM13.4736 5.93066H10.5293C10.0154 5.93074 9.59871 6.34741 9.59863 6.86133V19.8057C9.5988 20.3195 10.0154 20.7363 10.5293 20.7363H13.4736C13.9873 20.7361 14.4041 20.3194 14.4043 19.8057V6.86133C14.4042 6.34752 13.9874 5.93092 13.4736 5.93066ZM5.13965 9.26465H2.19629C1.68226 9.26465 1.26562 9.68128 1.26562 10.1953V19.8057C1.26579 20.3196 1.68236 20.7363 2.19629 20.7363H5.13965C5.65358 20.7363 6.07015 20.3196 6.07031 19.8057V10.1953C6.07031 9.68128 5.65368 9.26465 5.13965 9.26465Z"
          stroke="#F4B33E"
          strokeWidth="1.86147"
        />
        <path
          d="M21.8066 0.930664H18.8623C18.3485 0.930917 17.9317 1.34752 17.9316 1.86133V19.8057C17.9318 20.3194 18.3486 20.7361 18.8623 20.7363H21.8066C22.3205 20.7363 22.7371 20.3195 22.7373 19.8057V1.86133C22.7372 1.34741 22.3206 0.930742 21.8066 0.930664ZM13.4736 5.93066H10.5293C10.0154 5.93074 9.59871 6.34741 9.59863 6.86133V19.8057C9.5988 20.3195 10.0154 20.7363 10.5293 20.7363H13.4736C13.9873 20.7361 14.4041 20.3194 14.4043 19.8057V6.86133C14.4042 6.34752 13.9874 5.93092 13.4736 5.93066Z"
          stroke="#CA3B7E"
          strokeWidth="1.86147"
        />
        <path
          d="M21.8066 0.930664H18.8623C18.3485 0.930917 17.9317 1.34752 17.9316 1.86133V19.8057C17.9318 20.3194 18.3486 20.7361 18.8623 20.7363H21.8066C22.3205 20.7363 22.7371 20.3195 22.7373 19.8057V1.86133C22.7372 1.34741 22.3206 0.930742 21.8066 0.930664Z"
          stroke="#6D90F7"
          strokeWidth="1.86147"
        />
      </g>
    </Svg>
  )
}

export const CorankDisabled = (props: IconProps) => {
  return (
    <Svg
      width={props.size || 24}
      height={props.size || 24}
      viewBox="0 0 24 21"
      fill="none"
    >
      <g opacity="0.5">
        <path
          d="M22.1387 0.930664H19.0039C18.4901 0.930892 18.0733 1.3475 18.0732 1.86133V19.1387C18.0733 19.6525 18.4901 20.0691 19.0039 20.0693H22.1387C22.6526 20.0693 23.0693 19.6526 23.0693 19.1387V1.86133C23.0693 1.34741 22.6526 0.930742 22.1387 0.930664ZM13.5674 5.77637H10.4326C9.91872 5.77652 9.50195 6.19407 9.50195 6.70801V19.1387C9.50203 19.6525 9.91876 20.0692 10.4326 20.0693H13.5674C14.0812 20.0692 14.498 19.6525 14.498 19.1387V6.70801C14.498 6.19407 14.0813 5.77652 13.5674 5.77637ZM4.99609 9.00781H1.86133C1.34737 9.00789 0.930672 9.4245 0.930664 9.93848V19.1387C0.930742 19.6526 1.34741 20.0693 1.86133 20.0693H4.99609C5.50988 20.0691 5.92668 19.6525 5.92676 19.1387V9.93848C5.92675 9.42459 5.50993 9.00804 4.99609 9.00781Z"
          stroke="#ABABAB"
          strokeWidth="1.86147"
        />
        <path
          d="M22.1387 0.930664H19.0039C18.4901 0.930892 18.0733 1.3475 18.0732 1.86133V19.1387C18.0733 19.6525 18.4901 20.0691 19.0039 20.0693H22.1387C22.6526 20.0693 23.0693 19.6526 23.0693 19.1387V1.86133C23.0693 1.34741 22.6526 0.930742 22.1387 0.930664ZM13.5674 5.77637H10.4326C9.91872 5.77652 9.50195 6.19407 9.50195 6.70801V19.1387C9.50203 19.6525 9.91876 20.0692 10.4326 20.0693H13.5674C14.0812 20.0692 14.498 19.6525 14.498 19.1387V6.70801C14.498 6.19407 14.0813 5.77652 13.5674 5.77637Z"
          stroke="#919191"
          strokeWidth="1.86147"
        />
        <path
          d="M22.1387 0.930664H19.0039C18.4901 0.930892 18.0733 1.3475 18.0732 1.86133V19.1387C18.0733 19.6525 18.4901 20.0691 19.0039 20.0693H22.1387C22.6526 20.0693 23.0693 19.6526 23.0693 19.1387V1.86133C23.0693 1.34741 22.6526 0.930742 22.1387 0.930664Z"
          stroke="#777777"
          strokeWidth="1.86147"
        />
      </g>
    </Svg>
  )
}

export const CorankLock = (props: IconProps) => {
  return (
    <Svg
      width={props.size || 8}
      height={props.size || 8}
      viewBox="0 0 8 8"
      fill="none"
    >
      <g clipPath="url(#clip0_57041_18985)">
        <path
          d="M6.00016 2.83333H5.66683V2.16667C5.66683 1.24667 4.92016 0.5 4.00016 0.5C3.08016 0.5 2.3335 1.24667 2.3335 2.16667V2.83333H2.00016C1.6335 2.83333 1.3335 3.13333 1.3335 3.5V6.83333C1.3335 7.2 1.6335 7.5 2.00016 7.5H6.00016C6.36683 7.5 6.66683 7.2 6.66683 6.83333V3.5C6.66683 3.13333 6.36683 2.83333 6.00016 2.83333ZM3.00016 2.16667C3.00016 1.61333 3.44683 1.16667 4.00016 1.16667C4.5535 1.16667 5.00016 1.61333 5.00016 2.16667V2.83333H3.00016V2.16667ZM6.00016 6.83333H2.00016V3.5H6.00016V6.83333ZM4.00016 5.83333C4.36683 5.83333 4.66683 5.53333 4.66683 5.16667C4.66683 4.8 4.36683 4.5 4.00016 4.5C3.6335 4.5 3.3335 4.8 3.3335 5.16667C3.3335 5.53333 3.6335 5.83333 4.00016 5.83333Z"
          fill={props.color || '#5E5E5E'}
        />
      </g>
      <defs>
        <clipPath id="clip0_57041_18985">
          <rect width="8" height="8" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  )
}

export const GooglePNG = require('../assets/google.png')
export const WechatPNG = require('../assets/wechat.png')
export const WechatPaymentPNG = require('../assets/wechat-pay-icon.png')
export const AlipayPNG = require('../assets/alipay-icon.png')
export const PaypalPNG = require('../assets/paypal-icon.png')

export const IconAssignTask = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="#000"
      d="M21 5.18 9.59 16.6l-4.24-4.24 1.41-1.41 2.83 2.83 10-10L21 5.18ZM11 20c-4.41 0-8-3.59-8-8s3.59-8 8-8c1.57 0 3.04.46 4.28 1.25l1.45-1.45A10.02 10.02 0 0 0 11 2C5.48 2 1 6.48 1 12s4.48 10 10 10c1.73 0 3.36-.44 4.78-1.22l-1.5-1.5c-1 .46-2.11.72-3.28.72Zm7-5h-3v2h3v3h2v-3h3v-2h-3v-3h-2v3Z"
    />
  </svg>
)

export const IconCreatedTask = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 9H13.45V6H10.55V9H8L12 13L16 9ZM19 3H4.99C3.88 3 3 3.9 3 5V19C3 20.1 3.88 21 4.99 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V16H8.56C9.25 17.19 10.53 18 12.01 18C13.49 18 14.76 17.19 15.46 16H19V19ZM19 14H14.01C14.01 15.1 13.11 16 12.01 16C10.91 16 10.01 15.1 10.01 14H5L4.99 5H19V14Z"
      fill="black"
    />
  </svg>
)

export const IconAssignedTask = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 9.83V14H13V9.83L14.59 11.41L16 10L12 6L8 10L9.41 11.41L11 9.83Z"
      fill="black"
    />
    <path
      d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V16H8.02C8.93 17.21 10.37 18 12 18C13.63 18 15.06 17.21 15.98 16H19V19ZM19 14H14.82C14.41 15.16 13.31 16 12 16C10.69 16 9.6 15.16 9.18 14H5V5H19V14Z"
      fill="black"
    />
  </svg>
)

export const IconAsssignedTasks = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 9.83V14H13V9.83L14.59 11.41L16 10L12 6L8 10L9.41 11.41L11 9.83Z"
      fill="black"
    />
    <path
      d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V16H8.02C8.93 17.21 10.37 18 12 18C13.63 18 15.06 17.21 15.98 16H19V19ZM19 14H14.82C14.41 15.16 13.31 16 12 16C10.69 16 9.6 15.16 9.18 14H5V5H19V14Z"
      fill="black"
    />
  </svg>
)
export const IconM = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <mask id="a" fill="#fff">
      <path d="M11.91 2.644a.116.116 0 0 0 .143 0c.503-.38 1.04-.712 1.611-.998 2.35-1.177 5.055-.693 6.966 1.02 1.126 1.008 1.863 2.298 2.21 3.872.11.493.163 1.128.16 1.902-.012 3.85-.013 7.588-.002 11.211 0 .323-.048.623-.146.901-.403 1.148-1.724 1.74-2.875 1.305a2.121 2.121 0 0 1-1.297-1.305c-.085-.231-.127-.702-.127-1.411l.016-10.629c.002-.864-.036-1.533-.657-2.158a2.04 2.04 0 0 0-1.148-.59c-1.39-.224-2.575.79-2.578 2.213-.006 3.674-.003 7.402.009 11.186.002.712-.056 1.206-.173 1.483-.933 2.2-4.225 1.575-4.233-.867-.011-3.844-.01-7.72.003-11.63.001-.434-.049-.781-.15-1.04-.715-1.83-3.372-1.848-4.07.003-.104.274-.156.619-.154 1.034.017 4.179.02 8.052.007 11.62-.002.773-.314 1.387-.935 1.84-.648.474-1.66.524-2.366.125C1.33 21.283.998 20.556 1 19.65c.011-3.851.011-7.733 0-11.646-.001-.68.047-1.24.146-1.679.76-3.367 3.905-5.734 7.353-5.252 1.241.174 2.44.796 3.411 1.57Z" />
    </mask>
    <path
      fill={props.color}
      stroke={props.color}
      strokeWidth={0.2}
      d="M11.91 2.644a.116.116 0 0 0 .143 0c.503-.38 1.04-.712 1.611-.998 2.35-1.177 5.055-.693 6.966 1.02 1.126 1.008 1.863 2.298 2.21 3.872.11.493.163 1.128.16 1.902-.012 3.85-.013 7.588-.002 11.211 0 .323-.048.623-.146.901-.403 1.148-1.724 1.74-2.875 1.305a2.121 2.121 0 0 1-1.297-1.305c-.085-.231-.127-.702-.127-1.411l.016-10.629c.002-.864-.036-1.533-.657-2.158a2.04 2.04 0 0 0-1.148-.59c-1.39-.224-2.575.79-2.578 2.213-.006 3.674-.003 7.402.009 11.186.002.712-.056 1.206-.173 1.483-.933 2.2-4.225 1.575-4.233-.867-.011-3.844-.01-7.72.003-11.63.001-.434-.049-.781-.15-1.04-.715-1.83-3.372-1.848-4.07.003-.104.274-.156.619-.154 1.034.017 4.179.02 8.052.007 11.62-.002.773-.314 1.387-.935 1.84-.648.474-1.66.524-2.366.125C1.33 21.283.998 20.556 1 19.65c.011-3.851.011-7.733 0-11.646-.001-.68.047-1.24.146-1.679.76-3.367 3.905-5.734 7.353-5.252 1.241.174 2.44.796 3.411 1.57Z"
      mask="url(#a)"
    />
  </svg>
)

export const IconPending = ({ size = 24 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <circle cx="7" cy="12" r="1" />
      <circle cx="12" cy="12" r="1" />
      <circle cx="17" cy="12" r="1" />
    </svg>
  )
}

export const IconArchived = 'archive-outline'
export const IconOpenContribution = 'plus-circle-outline'

export const TimeLineIcon = (props: {
  item: TimeLineObject | TimeLine
  size?: number
}) => {
  const { item, size = 20 } = props
  const target = 'target' in item ? item.target : item.targetType
  if (
    [
      TimeLineAction.ContributionBumpedUp,
      TimeLineAction.ContributionBumpedDown,
    ].includes(item.action)
  ) {
    return item.action === TimeLineAction.ContributionBumpedUp ? (
      <Icon3dBumpUp size={size} color={'#8596d4'} />
    ) : (
      <Icon3dBumpDown size={size} color={'#8596d4'} />
    )
  }
  return <LevelIcon target={target} size={size} color={'#8596d4'} />
}

export const LevelIcon = (props: IconProps & { target: TargetType }) => {
  const { target, ...other } = props

  const map = {
    [TargetType.Cluster]: IconCluster,
    [TargetType.Node]: IconNode,
    [TargetType.Article]: IconPerspective,
    [TargetType.Contribution]: Icon3dContributions,
  }
  return map[target]?.(other) || null
}

export const SmartPhone = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      {...props}
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z" />
    </svg>
  )
}

export const MelddTextLogo = () => {
  return (
    <svg
      width="200"
      height="80"
      viewBox="0 0 200 80"
      xmlns="http://www.w3.org/2000/svg"
    >
      <text x="10" y="60" font-family="Arial" font-size="60" font-weight="bold">
        <tspan fill="#1B2B3B">mel</tspan>
        <tspan fill="#4B9CD3">d</tspan>
        <tspan fill="#1B2B3B">d</tspan>
      </text>
    </svg>
  )
}

export const VisibilityIcon = (props: IconProps & { toggled?: boolean }) => {
  const { toggled, ...other } = props
  if (toggled) {
    return (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...other}
      >
        <g clipPath="url(#clip0_56506_29951)">
          <rect x="4" y="4" width="40" height="40" rx="20" fill="#5E5E5E" />
          <path
            d="M31 15H17C15.89 15 15 15.9 15 17V31C15 32.1 15.89 33 17 33H31C32.1 33 33 32.1 33 31V17C33 15.9 32.11 15 31 15ZM31 31H17V19H31V31ZM24 22.5C25.84 22.5 27.48 23.46 28.34 25C27.48 26.54 25.84 27.5 24 27.5C22.16 27.5 20.52 26.54 19.66 25C20.52 23.46 22.16 22.5 24 22.5ZM24 21C21.27 21 18.94 22.66 18 25C18.94 27.34 21.27 29 24 29C26.73 29 29.06 27.34 30 25C29.06 22.66 26.73 21 24 21ZM24 26.5C23.17 26.5 22.5 25.83 22.5 25C22.5 24.17 23.17 23.5 24 23.5C24.83 23.5 25.5 24.17 25.5 25C25.5 25.83 24.83 26.5 24 26.5Z"
            fill="white"
          />
        </g>
        <defs>
          <ClipPath id="clip0_56506_29951">
            <rect x="4" y="4" width="40" height="40" rx="20" fill="white" />
          </ClipPath>
        </defs>
      </svg>
    )
  }
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_56506_29929)">
        <path
          d="M31 15H17C15.89 15 15 15.9 15 17V31C15 32.1 15.89 33 17 33H31C32.1 33 33 32.1 33 31V17C33 15.9 32.11 15 31 15ZM31 31H17V19H31V31ZM24 22.5C25.84 22.5 27.48 23.46 28.34 25C27.48 26.54 25.84 27.5 24 27.5C22.16 27.5 20.52 26.54 19.66 25C20.52 23.46 22.16 22.5 24 22.5ZM24 21C21.27 21 18.94 22.66 18 25C18.94 27.34 21.27 29 24 29C26.73 29 29.06 27.34 30 25C29.06 22.66 26.73 21 24 21ZM24 26.5C23.17 26.5 22.5 25.83 22.5 25C22.5 24.17 23.17 23.5 24 23.5C24.83 23.5 25.5 24.17 25.5 25C25.5 25.83 24.83 26.5 24 26.5Z"
          fill="black"
        />
      </g>
      <defs>
        <ClipPath id="clip0_56506_29929">
          <rect x="4" y="4" width="40" height="40" rx="20" fill="white" />
        </ClipPath>
      </defs>
    </svg>
  )
}

export const IconBumpUp = (props: PressableIconProps) => {
  const { size = '40', color, disabled, ...other } = props
  const { t } = useTranslation('bumps')

  const icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
    >
      <g clipPath="url(#clip0_56636_4623)">
        <rect
          width="40"
          height="40"
          rx="20"
          fill="#4C4546"
          opacity={disabled ? 0.5 : 1}
        />
        <g filter="url(#filter0_ii_56636_4623)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.0577 14.6154C19.4787 13.8937 20.5213 13.8937 20.9423 14.6154L26.043 23.3594C26.4672 24.0867 25.9426 25 25.1007 25H14.8993C14.0574 25 13.5328 24.0867 13.957 23.3594L19.0577 14.6154Z"
            fill="#C6C6C6"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_ii_56636_4623"
          x="13.8068"
          y="13.7469"
          width="12.3865"
          height="11.6894"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.654545" />
          <feGaussianBlur stdDeviation="0.163636" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_56636_4623"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.545455" />
          <feGaussianBlur stdDeviation="0.218182" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_56636_4623"
            result="effect2_innerShadow_56636_4623"
          />
        </filter>
        <clipPath id="clip0_56636_4623">
          <rect width="40" height="40" rx="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
  return (
    <TouchableIconWithToolTip
      icon={icon}
      disabled={disabled}
      tooltip={t('Up')}
      {...other}
    />
  )
}

export const IconBumpDown = (props: PressableIconProps) => {
  const { size = '40', color, disabled, ...other } = props
  const { t } = useTranslation('bumps')

  const icon = (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_56636_4503)">
        <rect
          width="40"
          height="40"
          rx="20"
          fill="#4C4546"
          opacity={disabled ? 0.5 : 1}
        />
        <g filter="url(#filter0_ii_56636_4503)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.9423 25.3846C20.5213 26.1063 19.4787 26.1063 19.0577 25.3846L13.957 16.6406C13.5328 15.9133 14.0574 15 14.8993 15L25.1007 15C25.9426 15 26.4672 15.9133 26.043 16.6406L20.9423 25.3846Z"
            fill="#C6C6C6"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_ii_56636_4503"
          x="13.8068"
          y="14.6727"
          width="12.3865"
          height="11.6894"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.654545" />
          <feGaussianBlur stdDeviation="0.163636" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_56636_4503"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.545455" />
          <feGaussianBlur stdDeviation="0.218182" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_56636_4503"
            result="effect2_innerShadow_56636_4503"
          />
        </filter>
        <clipPath id="clip0_56636_4503">
          <rect width="40" height="40" rx="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
  return (
    <TouchableIconWithToolTip
      icon={icon}
      disabled={disabled}
      tooltip={t('Down')}
      {...other}
    />
  )
}

export const IconBumpScores = (props: PressableIconProps) => {
  const { size, color, ...other } = props
  const { t } = useTranslation('bumps')

  const icon = (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_ii_56636_3693)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.64157 5.66976C4.92859 5.17773 5.63952 5.17773 5.92654 5.66977L9.88155 12.4498C10.1708 12.9456 9.81312 13.5684 9.23906 13.5684H1.32906C0.754992 13.5684 0.397316 12.9456 0.68657 12.4498L4.64157 5.66976Z"
          fill="url(#paint0_linear_56636_3693)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.64157 5.66976C4.92859 5.17773 5.63952 5.17773 5.92654 5.66977L9.88155 12.4498C10.1708 12.9456 9.81312 13.5684 9.23906 13.5684H1.32906C0.754992 13.5684 0.397316 12.9456 0.68657 12.4498L4.64157 5.66976Z"
          fill="url(#paint1_radial_56636_3693)"
          style={{ mixBlendMode: 'overlay' }}
        />
      </g>
      <g filter="url(#filter1_ii_56636_3693)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.4265 12.467C13.1395 12.959 12.4286 12.959 12.1416 12.467L8.18657 5.68695C7.89732 5.19109 8.25499 4.56836 8.82906 4.56836L16.7391 4.56836C17.3131 4.56836 17.6708 5.19109 17.3815 5.68695L13.4265 12.467Z"
          fill="url(#paint2_linear_56636_3693)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.4265 12.467C13.1395 12.959 12.4286 12.959 12.1416 12.467L8.18657 5.68695C7.89732 5.19109 8.25499 4.56836 8.82906 4.56836L16.7391 4.56836C17.3131 4.56836 17.6708 5.19109 17.3815 5.68695L13.4265 12.467Z"
          fill="url(#paint3_radial_56636_3693)"
          style={{ mixBlendMode: 'overlay' }}
        />
      </g>
      <defs>
        <filter
          id="filter0_ii_56636_3693"
          x="0.584106"
          y="5.07764"
          width="9.3999"
          height="8.78824"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.446286" />
          <feGaussianBlur stdDeviation="0.111571" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_56636_3693"
          />
          4
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.371905" />
          <feGaussianBlur stdDeviation="0.148762" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_56636_3693"
            result="effect2_innerShadow_56636_3693"
          />
        </filter>
        <filter
          id="filter1_ii_56636_3693"
          x="8.08411"
          y="4.34522"
          width="9.3999"
          height="8.78824"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.446286" />
          <feGaussianBlur stdDeviation="0.111571" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_56636_3693"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.371905" />
          <feGaussianBlur stdDeviation="0.148762" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_56636_3693"
            result="effect2_innerShadow_56636_3693"
          />
        </filter>
        <linearGradient
          id="paint0_linear_56636_3693"
          x1="10.2954"
          y1="8.16836"
          x2="0.257027"
          y2="13.1203"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.141082" stop-color="#576265" />
          <stop offset="0.329118" stop-color="#9EA1A1" />
          <stop offset="0.385829" stop-color="#848B8A" />
          <stop offset="0.545243" stop-color="#576265" />
          <stop offset="0.794548" stop-color="#576265" />
          <stop offset="0.875645" stop-color="#757A7B" />
          <stop offset="1" stop-color="#576265" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_56636_3693"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1.70451 3.66836) rotate(58.7816) scale(7.36672 8.33818)"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_56636_3693"
          x1="7.77269"
          y1="9.96836"
          x2="17.8111"
          y2="5.01637"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.141082" stop-color="#576265" />
          <stop offset="0.329118" stop-color="#9EA1A1" />
          <stop offset="0.385829" stop-color="#848B8A" />
          <stop offset="0.545243" stop-color="#576265" />
          <stop offset="0.794548" stop-color="#576265" />
          <stop offset="0.875645" stop-color="#757A7B" />
          <stop offset="1" stop-color="#576265" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_56636_3693"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.3636 14.4684) rotate(-121.218) scale(7.36672 8.33818)"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </radialGradient>
      </defs>
    </svg>
  )
  return (
    <TouchableIconWithToolTip icon={icon} tooltip={t('scores')} {...other} />
  )
}

export const EyeIcon = (props: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '16'}
      height={props.size || '16'}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M8.00008 4.33333C10.5267 4.33333 12.7801 5.75333 13.8801 8C12.7801 10.2467 10.5267 11.6667 8.00008 11.6667C5.47341 11.6667 3.22008 10.2467 2.12008 8C3.22008 5.75333 5.47341 4.33333 8.00008 4.33333ZM8.00008 3C4.66675 3 1.82008 5.07333 0.666748 8C1.82008 10.9267 4.66675 13 8.00008 13C11.3334 13 14.1801 10.9267 15.3334 8C14.1801 5.07333 11.3334 3 8.00008 3ZM8.00008 6.33333C8.92008 6.33333 9.66675 7.08 9.66675 8C9.66675 8.92 8.92008 9.66667 8.00008 9.66667C7.08008 9.66667 6.33341 8.92 6.33341 8C6.33341 7.08 7.08008 6.33333 8.00008 6.33333ZM8.00008 5C6.34675 5 5.00008 6.34667 5.00008 8C5.00008 9.65333 6.34675 11 8.00008 11C9.65341 11 11.0001 9.65333 11.0001 8C11.0001 6.34667 9.65341 5 8.00008 5Z"
        fill={props.color || 'black'}
      />
    </svg>
  )
}
